const model = {
    _id: '',
    id: '',
    createdAt: '',
    updatedAt: '',
    prelim_universal: false,
    prelim_selective: false,
    prelim_selective_one: false,
    prelim_selective_two: false,
    prelim_selective_three: false,
    prelim_selective_four: false,
    prelim_selective_five: false,
    prelim_selective_six: false,
    prelim_selective_seven: false,
    prelim_noprotocol: false,
    prelim_other: false,
    prelim_other_text: '',

    one_exp_a: false,
    one_exp_b: false,
    one_exp_c: false,
    one_exp_d: false,
    one_exp_e: false,
    one_exp_f: false,

    one_vul_a: false,
    one_vul_b: false,
    one_vul_c: false,
    one_vul_d: false,
    one_vul_e: false,
    one_vul_f: false,

    one_vul_g: false,
    one_vul_h: false,
    one_vul_i: false,
    one_vul_j: false,
    one_vul_k: false,
    one_vul_other: false,
    one_vul_other_text: '',
    one_no_circumstances: false,
    section_1_status: '', // Indicated, Concern, Not Enough Information

    two_exp_a: false,
    two_exp_b: false,
    two_exp_c: false,
    two_exp_d: false,
    two_exp_e: false,
    two_exp_f: false,
    two_exp_g: false,
    two_exp_h: false,

    two_vul_a: false,
    two_vul_b: false,
    two_vul_c: false,
    two_vul_d: false,
    two_vul_other: false,
    two_vul_other_text: '',
    two_no_circumstances: false, // If selected, the value for the indicator is 1.(huh?) This is similar to the allies.laborscreening table.
    section_2_status: '', // Indicated, Concern, Not Enough Information

    three_a: false,
    three_b: false,
    three_c: false,
    three_d: false,
    three_e: false,
    three_f: false,
    three_g: false,
    three_h: false,
    three_i: false,
    three_j: false,
    three_k: false,
    three_other: false,
    three_other_text: '',
    three_no_certain: false,
    three_no_certain_text: '',
    three_no_circumstances: false,
    section_3_status: '', // Indicated, Concern, Not Enough Information

    conclusion: '',
    person: '',
    createdBy: '',
    updatedBy: '',
    organizationCreator: '',
    organizationOwner: '',
    location: '',
    program: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/traffickingScreening.js